export const buildBadgeUrl = (type, assetsUrl = 'https://e-cdns-assets.dzcdn.net', locale = 'en')=>{
    return `${assetsUrl}/common/images/${type}-store-badge/${locale}.svg`;
};

//# sourceMappingURL=common.js.map